import { useNavigate } from 'react-router-dom';

import { useAuth } from 'context/AuthContext';

import { DimGlyph, IconSprout } from 'components/rebrand/icons';
import { DIMENSOES, gigabytesToSelos, hexToRgba } from 'components/rebrand/mappings';

export function DimensionPanel() {
  const { user, currentCycle } = useAuth();
  const navigate = useNavigate();

  const saldoGigabytes = user?.point_categories?.point_behavior || 0;
  const selos = gigabytesToSelos(saldoGigabytes);
  const podeReconhecer = currentCycle?.status === 'open' && saldoGigabytes >= 100;

  return (
    <section className="rb-dimensions" data-step="2">
      <div className="rb-dimensions__head">
        <div>
          <h2 className="rb-dimensions__title" tabIndex={0}>
            Reconheça seus colegas
          </h2>
          <p className="rb-dimensions__subtitle">Cada selo reconhece um comportamento que fortalece a nossa Cultura.</p>
        </div>

        <div className="rb-seedbalance" tabIndex={0} aria-label={`${selos} selos disponíveis neste ciclo`}>
          <div className="rb-seedbalance__icon">
            <IconSprout color="#3f9a2f" size={23} />
          </div>
          <div>
            <div className="rb-seedbalance__value-row">
              <span className="rb-seedbalance__value">{selos}</span>
              <span className="rb-seedbalance__unit">selo{selos === 1 ? '' : 's'}</span>
            </div>
            <div className="rb-seedbalance__hint">disponíveis neste ciclo</div>
          </div>
        </div>
      </div>

      <div className="rb-dim-grid">
        {DIMENSOES.map((dimensao, i) => (
          <div key={dimensao.id} className="rb-card rb-rise" style={{ animationDelay: `${i * 70}ms` }}>
            <div className="rb-card__icon" style={{ background: hexToRgba(dimensao.color, 0.12) }}>
              <DimGlyph id={dimensao.id} color={dimensao.color} size={30} />
            </div>
            <h3 className="rb-card__title" style={{ color: dimensao.color }}>
              {dimensao.label}
            </h3>
            <p className="rb-card__desc">{dimensao.descricao}</p>
            <button
              type="button"
              className="rb-dimbtn"
              style={{ ['--c' as any]: dimensao.color }}
              disabled={!podeReconhecer}
              onClick={() => navigate(`/reconhecer?behavior=${dimensao.id}`)}
              aria-label={`Reconhecer colega em ${dimensao.label}. Abre a página de reconhecimento.`}
            >
              Reconheça
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
